import startsWith from 'lodash/startsWith';

let appPath = null;

export function getAppPath() {
    return appPath || (appPath = resolveAppPath());
}

function resolveAppPath() {
    const tag = window && window.document.head.querySelector("meta[name='app-path']");
    return tag && tag.content || '/';
}

export default function path(relativeUrl) {
    let url = getAppPath();

    if (typeof relativeUrl === 'string' && relativeUrl.length > 0) {
        if (startsWith(relativeUrl, '~/')) {
            url += relativeUrl.substr(2);
        }
        else if (startsWith(relativeUrl, '/')) {
            url += relativeUrl.substr(1);
        }
        else {
            url += relativeUrl;
        }
    }
    return url;
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/internal/appPath.js